import { HOST_URL } from '../config'
import { HttpStatus } from '../constants/http-status.enum'
import type { ApiResponse } from './index'

export interface IUsbFlashManifestSummary {
    id: string
    title: string
    chip?: string
    model?: number
    version?: string
    createdAt: string
    updatedAt: string
}

export interface IUsbFlashManifestV1 {
    flash_files: Record<string, string>
    extra_esptool_args?: {
        chip?: string
        before?: string
        after?: string
        stub?: boolean
    }
    [key: string]: unknown
}

export interface IUsbFlashUploadRequest {
    id?: string
    title?: string
    model?: number
    chip?: 'esp32s3' | 'esp32c6' | 'esp32p4'
    version?: string
    overwrite?: boolean
    manifest: IUsbFlashManifestV1
    files: Record<string, string>
}

export async function listUsbFlashManifests(): Promise<ApiResponse<IUsbFlashManifestSummary[]>> {
    const response = await fetch(`${HOST_URL}usb-flash-artifacts/manifests`, {
        method: 'GET',
        credentials: 'include',
    })
    const result = (await response.json()) as ApiResponse<IUsbFlashManifestSummary[]>
    if (response.status !== HttpStatus.Ok) {
        throw new Error(result.message || 'Failed to load manifests')
    }
    return result
}

export async function uploadUsbFlashArtifact(payload: IUsbFlashUploadRequest): Promise<ApiResponse<IUsbFlashManifestSummary>> {
    const response = await fetch(`${HOST_URL}usb-flash-artifacts/upload`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
    })
    const result = (await response.json()) as ApiResponse<IUsbFlashManifestSummary>
    if (response.status !== HttpStatus.Ok) {
        throw new Error(result.message || 'Upload failed')
    }
    return result
}

export async function deleteUsbFlashManifest(id: string): Promise<ApiResponse<null>> {
    const response = await fetch(`${HOST_URL}usb-flash-artifacts/manifests/${encodeURIComponent(id)}`, {
        method: 'DELETE',
        credentials: 'include',
    })
    const result = (await response.json()) as ApiResponse<null>
    if (response.status !== HttpStatus.Ok) {
        throw new Error(result.message || 'Delete failed')
    }
    return result
}
